var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}},[_c('path',{attrs:{"stroke":"currentColor","d":"M4 13.5h20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }